import { Injectable } from '@angular/core';
import { AuthService, DeviceVerifyPayload, LoginPayload } from './auth.service';
import { ProfileService } from './profile.service';
import { BusinessAccountService } from './business-account.service';
import { TransactionService } from './transaction.service';
import { CaissierService } from './caissier.service';
import { AdminService } from './admin.service';
import { PartnerService } from './partner.service';
import { GestionnaireService } from './gestionnaire.service';
import { FileUploadService } from './file-upload.service';
import { DepotClientNetRequest } from '../models/DepotClientNetRequest';
import { BusinessDepotRequest } from '../models/businessDepotRequest';
import { RetraitClientNetRequest } from '../models/retraitClientNetRequest';
import { PrelevementSoftPayRequest } from '../models/prelevementSoftPayRequest';
import { CaissePrelevement } from '../models/caissePrelevement';
import { CaisseDepot } from '../models/caisseDepot';
import { TranfertFormPrimaire } from '../models/tranfertFormPrimaire';
import { TransfertFormBussiness } from '../models/transfertFormBussiness';

@Injectable({ providedIn: 'root' })
export class PayService {

  constructor(
    private auth: AuthService,
    private profile: ProfileService,
    private business: BusinessAccountService,
    private transaction: TransactionService,
    private caissier: CaissierService,
    private admin: AdminService,
    private partner: PartnerService,
    private gestionnaire: GestionnaireService,
    private fileUpload: FileUploadService,
  ) { }

  // Auth
  saveUsername(username) { return this.auth.saveUsername(username); }
  findEmail(email) { return this.auth.findEmail(email); }
  findPhone(phone) { return this.auth.findPhone(phone); }
  saveUser(user) { return this.auth.saveUser(user); }
  getlistPays() { return this.auth.getlistPays(); }
  requestPasswordReset(identifier) { return this.auth.requestPasswordReset(identifier); }
  confirmPasswordReset(data) { return this.auth.confirmPasswordReset(data); }
  login(user: LoginPayload) { return this.auth.login(user); }
  verifyTrustedDevice(payload: DeviceVerifyPayload) { return this.auth.verifyTrustedDevice(payload); }
  refresh(refreshToken: string) { return this.auth.refresh(refreshToken); }
  savetoken(jwt, secure, confirmphone, confirmCNi) { return this.auth.savetoken(jwt, secure, confirmphone, confirmCNi); }
  loadToken() { return this.auth.loadToken(); }

  // Profile
  getPincodePourAchat(email: string) { return this.profile.getPincodePourAchat(email); }
  getPincodeRetrait(email: string) { return this.profile.getPincodeRetrait(email); }
  getPinretraitBussness(accountnumber: string) { return this.profile.getPinretraitBussness(accountnumber); }
  getUser(username) { return this.profile.getUser(username); }
  getUtilisateursInformations(email) { return this.profile.getUtilisateursInformations(email); }
  addsecretQuestion(id, formdata) { return this.profile.addsecretQuestion(id, formdata); }
  updateLanguage(lang: string) { return this.profile.updateLanguage(lang); }
  changeUserinformation(id, formdata) { return this.profile.changeUserinformation(id, formdata); }
  getUserContactTelephonique() { return this.profile.getUserContactTelephonique(); }
  ConfirmationTokenSMS(phone) { return this.profile.ConfirmationTokenSMS(phone); }
  confirmContactNumber(token) { return this.profile.confirmContactNumber(token); }
  getUserIdentity() { return this.profile.getUserIdentity(); }
  getSecurityStatus(username: string) { return this.profile.getSecurityStatus(username); }
  updateUserPassword(payload: { code: string, password: string, username: string }) { return this.profile.updateUserPassword(payload); }
  setupSecurity(payload: {
    secretQuestion: string; secretAnswer: string; secretPin: string; contraintPin: string; username: string;
  }) {
    return this.profile.setupSecurity(payload);
  }
  verifySecretAnswer(payload: { answer: string; username: string; }) {
    return this.profile.verifySecretAnswer(payload);
  }
  securityPinForgotInit(payload: { usernameOrEmail: string }) {
    return this.profile.securityPinForgotInit(payload);
  }
  securityPinForgotConfirm(payload: { usernameOrEmail: string; otp: string; newSecretPin: string }) {
    return this.profile.securityPinForgotConfirm(payload);
  }

  updateSecurityCode(payload: { answer: string; oldSecretPin: string; newSecretPin: string; username: string }) {
    return this.profile.updateSecurityCode(payload);
  }

  // Business accounts
  addUtilisateurBussnessAccount(data, username) { return this.business.addUtilisateurBussnessAccount(data, username); }
  getAllUtilisateurBaccount(username) { return this.business.getAllUtilisateurBaccount(username); }
  UpdateUtilisateurBussnessAccount(formdata, id) { return this.business.UpdateUtilisateurBussnessAccount(formdata, id); }
  removeBaccount(id) { return this.business.removeBaccount(id); }
  maketransfertVersSoldeInitial(accountid) { return this.business.maketransfertVersSoldeInitial(accountid); }
  getcompteBussinessSolde(baccountNumber) { return this.business.getcompteBussinessSolde(baccountNumber); }
  updateCaisierInformation(id, idcaissier, formdata) { return this.business.updateCaisierInformation(id, idcaissier, formdata); }
  saveCaissier(id, formdata) { return this.business.saveCaissier(id, formdata); }
  getCaissiers(id) { return this.business.getCaissiers(id); }
  prelevementCompteclient(fpayload: CaissePrelevement) { return this.business.prelevementCompteclient(fpayload); }
  depotClient(fpayload: CaisseDepot) { return this.business.depotClient(fpayload); }
  retraitClient(formdata, username, accountid) { return this.business.retraitClient(formdata, username, accountid); }
  getAccountInformation(account) { return this.business.getAccountInformation(account); }
  getcompteBussiness(accountid) { return this.business.getcompteBussiness(accountid); }

  // Transactions
  transfertPrimaire(formdata: TranfertFormPrimaire) { return this.transaction.transfertPrimaire(formdata); }
  transfertBussness(formdata: TransfertFormBussiness) { return this.transaction.transfertBussness(formdata); }
  getUtilisateurAchats() { return this.transaction.getUtilisateurAchats(); }
  getUtilisateurDepots() { return this.transaction.getUtilisateurDepots(); }
  getUtilisateurRetrais() { return this.transaction.getUtilisateurRetrais(); }
  getUtilisateurTransferts() { return this.transaction.getUtilisateurTransferts(); }
  getUtilisateurMensualites() { return this.transaction.getUtilisateurMensualites(); }
  verifierCodeDeSecurite(code, username) { return this.transaction.verifierCodeDeSecurite(code, username); }
  getUtilisateursBaccountAchats(baccountNumber) { return this.transaction.getUtilisateursBaccountAchats(baccountNumber); }
  getUtilisateursBaccountMensualites(baccountNumber) { return this.transaction.getUtilisateursBaccountMensualites(baccountNumber); }
  getUtilisateursBussnessTransfertTransaction(baccountNumber) { return this.transaction.getUtilisateursBussnessTransfertTransaction(baccountNumber); }
  getUtilisateursBaccountRetraits(baccountNumber) { return this.transaction.getUtilisateursBaccountRetraits(baccountNumber); }
  getUtilisateursBaccountDepots(baccountNumber) { return this.transaction.getUtilisateursBaccountDepots(baccountNumber); }
  getUtilisateursBaccountFacturation(baccountNumber) { return this.transaction.getUtilisateursBaccountFacturation(baccountNumber); }
  updateFacturation(facturationid, typ) { return this.transaction.updateFacturation(facturationid, typ); }
  transfertMensualite(id, baccountNumber) { return this.transaction.transfertMensualite(id, baccountNumber); }
  prelevementSoftPay(payload: PrelevementSoftPayRequest) { return this.transaction.prelevementSoftPay(payload); }
  paySubscription(payload: {
    primaryAccountNumber: string;
    businessAccountNumber: string;
    amount: number;
    currency?: string;
    referenceId?: number;
    periodicity?: 'MONTHLY' | 'YEARLY';
    autoRenew?: boolean;
  }) { return this.transaction.paySubscription(payload); }
  confirmDelivery(purchaseTransactionId: number, payload: { businessAccountId?: number; businessAccountCode?: string; currency?: string; releaseNow?: boolean; }) {
    return this.transaction.confirmDelivery(purchaseTransactionId, payload);
  }

  requestReturn(purchaseTransactionId: number, payload: { businessAccountId?: number; businessAccountCode?: string; currency?: string; amount?: number; reason?: string; }) {
    return this.transaction.requestReturn(purchaseTransactionId, payload);
  }

  confirmReturn(purchaseTransactionId: number, payload: { businessAccountId?: number; businessAccountCode?: string; currency?: string; }) {
    return this.transaction.confirmReturn(purchaseTransactionId, payload);
  }

  // Caissier





  // Admin
  ajouterPartenaire(formdata) { return this.admin.ajouterPartenaire(formdata); }
  ajouterGestionaire(formdata) { return this.admin.ajouterGestionaire(formdata); }
  afficherGestionaires() { return this.admin.afficherGestionaires(); }
  afficherPartenaires() { return this.admin.afficherPartenaires(); }
  getprimaryAccounts() { return this.admin.getprimaryAccounts(); }
  getBussnessAcounts() { return this.admin.getBussnessAcounts(); }
  getprimaryAccount(id) { return this.admin.getprimaryAccount(id); }
  getprimaryAccountAchats(id) { return this.admin.getprimaryAccountAchats(id); }
  getprimaryAccountDepots(id) { return this.admin.getprimaryAccountDepots(id); }
  getprimaryAccountRetraits(id) { return this.admin.getprimaryAccountRetraits(id); }
  getprimaryAccountMensualite(id) { return this.admin.getprimaryAccountMensualite(id); }
  getBussnessAcountsUtilisateur(id) { return this.admin.getBussnessAcountsUtilisateur(id); }
  getBussnessAccountCaissiers(id) { return this.admin.getBussnessAccountCaissiers(id); }
  getBussnessAccountAchats(id) { return this.admin.getBussnessAccountAchats(id); }
  getBussnessAccountDepots(id) { return this.admin.getBussnessAccountDepots(id); }
  getBussnessAccountRetraits(id) { return this.admin.getBussnessAccountRetraits(id); }
  getBussnessAccountMensualites(id) { return this.admin.getBussnessAccountMensualites(id); }
  getBussnessAccountCodeRetraits(id) { return this.admin.getBussnessAccountCodeRetraits(id); }
  utilisateurAddGestionaire(idUtilisateur, idgestionaire) { return this.admin.utilisateurAddGestionaire(idUtilisateur, idgestionaire); }
  ajouterSoftPayaccount(formdata) { return this.admin.ajouterSoftPayaccount(formdata); }
  getSoftPayOperators() { return this.admin.getSoftPayOperators(); }
  ajouterMembreAdmin(formdata) { return this.admin.ajouterMembre(formdata); }
  updatesoftPayaccount(id, formdata) { return this.admin.updatesoftPayaccount(id, formdata); }
  adminUpdateUserPassword(id) { return this.admin.adminUpdateUserPassword(id); }
  getUtilisateur(id) { return this.admin.getUtilisateur(id); }
  findGestionaire(id) { return this.admin.findGestionaire(id); }
  getUserContactTelephoniqueAdmin(id) { return this.admin.getUserContactTelephoniqueAdmin(id); }
  getUserIdentificationAdmin(id) { return this.admin.getUserIdentificationAdmin(id); }
  activationCompteUtilisateur(userid) { return this.admin.activationCompteUtilisateur(userid); }
  desactiverCompteUtilisateur(userid) { return this.admin.desactiverCompteUtilisateur(userid); }
  activerBaccounUser(accountid) { return this.admin.activerBaccounUser(accountid); }
  desactiverAccountUser(accountid) { return this.admin.desactiverAccountUser(accountid); }
  messageActivationImpossible(userid, typ) { return this.admin.messageActivationImpossible(userid, typ); }

  // Partenaire


  depotClientNetSurComptePrimaire(payload: DepotClientNetRequest) { return this.partner.depotClientNetSurComptePrimaire(payload); }
  depotClientNetSurCompteBusiness(payload: BusinessDepotRequest) { return this.partner.depotClientNetSurCompteBusiness(payload); }


  retraitClientNetSurComptePrimaire(payload: RetraitClientNetRequest) { return this.partner.retraitClientNetSurComptePrimaire(payload); }
  retraitClientNetSurCompteBusiness(payload: RetraitClientNetRequest) { return this.partner.retraitClientNetSurCompteBusiness(payload); }


  getPartenaireMensualite(username) { return this.partner.getPartenaireMensualite(username); }

  getPartenairebAccount(username) { return this.partner.getPartenairebAccount(username); }
  getEmployeeOperationSecurity(username) { return this.partner.getEmployeeOperationSecurity(username); }
  getEmployeeStatus(username) { return this.partner.getEmployeeStatus(username); }
  activateEmployeeFirstLogin(payload: { matriculeEmploye: string; password: string; confirmPassword: string; }) {
    return this.partner.activateEmployeeFirstLogin(payload);
  }

  ajouterPartenairePartenaire(formdata, username) { return this.partner.ajouterPartenairePartenaire(formdata, username); }
  updateNouveauPartenaire(username, partenaireid, formdata) { return this.partner.updateNouveauPartenaire(username, partenaireid, formdata); }

  getCaissiersPartenaire(username) { return this.partner.getCaissiersPartenaire(username); }
  getAvailableEmployeeRoles(username) { return this.partner.getAvailableEmployeeRoles(username); }

  getallPaiementTransaction() { return this.partner.getallPaiementTransaction(); }



  getFacturesBaccount() { return this.partner.getFacturesBaccount(); }

  transfertMensualiteForce(id, baccountNumber) { return this.partner.transfertMensualiteForce(id, baccountNumber); }

  getMensualiteAndTaxesList(accountid) { return this.partner.getMensualiteAndTaxesList(accountid); }

  // Gestionnaire
  getUtilisateurGestionnaire() { return this.gestionnaire.getUtilisateurGestionnaire(); }

  // Files
  uploadFile(FormData, numero, usernameTarget?: string) { return this.fileUpload.uploadFile(FormData, numero, usernameTarget); }

  saveConnectedUser(data) { return this.auth.saveConnectedUser(data); }



}
